import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Button,
    Container,
    TextField,
    Typography,
    Paper,
    Grid,
    useTheme,
} from '@mui/material';

const VerifyIdentity: React.FC = () => {
    const navigate = useNavigate();
    const theme = useTheme();

    const demoData = {
        bvn: '2211234567890',
        nin: '98765432109'
    };

    const handleContinue = (): void => {
        navigate('/dashboard');
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                backgroundColor: theme.palette.background.default,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 2,
            }}
        >
            <Container maxWidth="sm" sx={{ p: 0 }}>
                <Paper elevation={3} sx={{ p: { xs: 2, sm: 4 }, width: '100%', borderRadius: 3 }}>
                    <Typography variant="h4" align="center" fontWeight="bold" mb={1}>
                        Welcome to NG Credit!
                    </Typography>
                    <Typography variant="body1" align="center" color="text.secondary" mb={4}>
                        The smartest way to build your credit. For this demo, we've pre-filled your identity details below. In a live application, these fields would be enabled for you to enter your own information.
                    </Typography>

                    <Typography variant="h5" align="center" fontWeight="bold" mb={3}>
                        Verify Your Identity
                    </Typography>
                    <Typography variant="body1" align="center" color="text.secondary" mb={4}>
                        Please confirm your details to continue. This information is required for security and to unlock credit-building features.
                    </Typography>

                    <Box
                        component="form"
                        sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}
                        onSubmit={(e: React.FormEvent) => {
                            e.preventDefault();
                            handleContinue();
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Bank Verification Number (BVN)"
                                    name="bvn"
                                    value={demoData.bvn}
                                    disabled
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="National Identification Number (NIN)"
                                    name="nin"
                                    value={demoData.nin}
                                    disabled
                                    required
                                />
                            </Grid>
                        </Grid>

                        <Button
                            fullWidth
                            type="submit"
                            variant="contained"
                            sx={{ mt: 2, py: 1.5, borderRadius: 3, textTransform: 'none' }}
                        >
                            Continue to Dashboard
                        </Button>
                    </Box>
                </Paper>
            </Container>
        </Box>
    );
};

export default VerifyIdentity;